// removed by extract-text-webpack-plugin
module.exports = {"SearchCriteria":"SearchBar__SearchCriteria__3Moj2","Button":"SearchBar__Button__2Pp7-","SearchBar":"SearchBar__SearchBar__uIBbI","Inline":"SearchBar__Inline__3Q6h7"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/SearchBar/SearchBar.css
// module id = 231
// module chunks = 1